<div class="custom-radio">
  <input type="radio" [id]="radius.id1" [name]="radius.name" checked>
  <label [for]="radius.id1">
    <span class="radio-circle"></span>
  </label>
  <span class="radio-text">{{radius.opcao1}}</span>

  <input type="radio" [id]="radius.id2" [name]="radius.name">
  <label [for]="radius.id2">
    <span class="radio-circle"></span>
  </label>
  <span class="radio-text">{{radius.opcao2}}</span>
</div>
